import { configureStore } from '@reduxjs/toolkit';
import { accountSlice } from './features/account';
import { campaignSlice } from './features/campaign';
// ...

export const store = configureStore({
  reducer: {
    account: accountSlice.reducer,
    campaign: campaignSlice.reducer,
  },
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
// Export the Store
export default store;
